import { useHistory } from "react-router-dom";
import styles from './index.module.css';
import { Typography, Box } from "@material-ui/core";
import { useSelector } from 'react-redux';
import { IAppState } from '../../../../store';
import { useTranslation } from 'react-i18next';

export interface IDrivers {
  totalDrivers: number
  vehiclesAllocated: number
  availableDrivers: number
}

const Drivers = ({ data }: { data: IDrivers }) => {
  const history = useHistory();
  const userState = useSelector((state: IAppState) => state.authReducer.user)
  const consumerState = useSelector((state: IAppState) => state.consumerWebsiteReducer)
  const { locale, currency } = consumerState.consumerWebsite.organisation
  const { t } = useTranslation();

  // const allocationPercentage = data ? (data.vehiclesAllocated / data.totalDrivers) * 100 : 0;

  return (
    <Box className={styles.enhancedCard}>
      <Box className={styles.cardContentEnhanced}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" style={{ fontWeight: 600, color: "#1e293b", fontSize: "18px" }}>
            {t("root:drivers")}
          </Typography>
          <Box className={styles.metricIcon} style={{ background: "linear-gradient(135deg, #f093fb, #f5576c)" }}>
            👥
          </Box>
        </Box>

        <Box>
          <Box style={{ margin: "10px 0" }}>
            <Box
              style={{
                padding: "15px",
                background: "linear-gradient(135deg, #f093fb, #f5576c)",
                borderRadius: "16px",
                color: "white",
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              <Typography variant="body2" style={{ fontSize: "12px", opacity: 0.9, marginBottom: "4px" }}>
                {t("root:totalDrivers")}
              </Typography>
              <Typography
                variant="h3"
                style={{ fontWeight: 700, fontSize: "32px", cursor: "pointer" }}
                onClick={() => history.push("/account/drivers")}
              >
                {data.totalDrivers}
              </Typography>
            </Box>

            <Box display="flex" style={{ gap: "12px" }}>
              <Box
                style={{
                  flex: 1,
                  padding: "10px",
                  backgroundColor: "#fdf2f8",
                  borderRadius: "12px",
                  border: "2px solid #ec4899",
                  textAlign: "center",
                }}
              >
                <Typography
                  variant="body2"
                  style={{ color: "#be185d", fontSize: "11px", fontWeight: 600, marginBottom: "4px" }}
                >
                  {t("root:vehiclesAllocated")}
                </Typography>
                <Typography
                  variant="h4"
                  style={{ color: "#be185d", fontWeight: 700, fontSize: "24px", cursor: "pointer" }}
                  onClick={() => history.push("/account/vehicles", {
                    showAllocatedVehicles: true
                  })}
                >
                  {data.vehiclesAllocated}
                </Typography>
              </Box>

              <Box
                style={{
                  flex: 1,
                  padding: "10px",
                  backgroundColor: "#f0fdf4",
                  borderRadius: "12px",
                  border: "2px solid #22c55e",
                  textAlign: "center",
                }}
              >
                <Typography
                  variant="body2"
                  style={{ color: "#15803d", fontSize: "11px", fontWeight: 600, marginBottom: "4px" }}
                >
                  {t("root:available")}
                </Typography>
                <Typography
                  variant="h4"
                  style={{ color: "#15803d", fontWeight: 700, fontSize: "24px", cursor: "pointer" }}
                  onClick={() => {
                    history.push("/account/drivers", {
                      showAvailableDrivers: true
                    })
                  }}
                >
                  {data.availableDrivers}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default Drivers